/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsVerifyUserAttribute204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsVerifyUserAttribute505Schema = z.any();

export const optionsVerifyUserAttributeMutationResponseSchema = z.lazy(() => optionsVerifyUserAttribute204Schema);
